import _ from 'lodash';
import questionItem from "@/components/questionItem.vue"
export default {
  /* :title="`${index + 1}.${item.title}`" */
  data() {
    return {
      qkey: 0,
      conselectedAns: {},
      // conselectedAns2: [{
      //   status: '',
      // }],
      showquestionlist: [],
      conselectedAns2: [],
      proqkey2: 1,
      temp: 0,
      showDetial_status: false,
      ErrorQuestionTemp: {},
      ModifyQuestionTemp: {},
      msgAnalyzeTemp: {},
      errMsg: '',
      AnalyzeType: 'student',
      // AnalyzeTypeList: [],
      conselectedShowDetial: [],
      conselectedShowStatus: [],
      questionTag_clone: [],
      ishover: {
        index: Number,
        index2: Number,
        status: Boolean,
      },
    };
  },
  // ( Object) conselectedAns,AllAns,ishover,conselectedShowStatus,selectedStatus , AnalyzeTypeList ,msgAnalyzeTemp ,conselectedShowDetial
  // (Boolean) allwaysAns 
  // @overEvent ,leaveEvent,selectAns,selectAns2,ShowCorrectAns , errorSubmit , modifyQuestions , sohwDetial_method
  props: {
    proqkey: Number,
    qkeyf2: Number,
    proTip: Boolean,
    proRe: Boolean,
    proStatus: Array,
    proOpenAns: Boolean,
  },
  methods: {
    showquestion(item) {
      const index = this.showquestionlist.indexOf(item.id);
      if (index == -1) {
        this.showquestionlist.push(item.id);
      } else {
        this.showquestionlist.splice(index, 1);
      }
    },
    overEvent(num, selNum, data) {
      const temp = {
        index: Number,
        index2: Number,
        status: Boolean,
      };
      temp.index = num - 1;
      temp.index2 = selNum;
      temp.status = data;
      this.ishover = _.cloneDeep(temp);
    },
    leaveEvent(num, selNum, data) {
      const temp = {
        index: Number,
        index2: Number,
        status: Boolean,
      };
      temp.index = num - 1;
      temp.index2 = selNum;
      temp.status = data;
      this.ishover = _.cloneDeep(temp);
    },
    addGroupQ(index, questionsnumber) {
      if (this.proqkey2 < this.totalQuestion) {
        this.proqkey2 = questionsnumber + 1;
        this.qkey = this.AllAns[questionsnumber].group;
        this.$emit('qkey2', this.qkey);
        this.$emit('proqkey2', this.proqkey2);
      }
    },
    lessQ(questionsnumber) {
      if (this.qkey !== 1) {
        if (this.single) {
          this.proqkey2 = questionsnumber - 1;
          this.qkey = this.AllAns[questionsnumber - 2].group;
          this.$emit('qkey2', this.qkey);
          this.$emit('proqkey2', this.proqkey2);
        }
      }
    },
    ChangeAnalyzeType(index, method) {
      this.$store.commit('exam/setAnalyzeTypeList', {
        myindex: index,
        mymethod: method,
      });
      // this.AnalyzeTypeList[index - 1] = method;
    },
    showAns(index) {
      if (this.selectedStatus2[index - 1] === true) {
        this.$store.commit('exam/setSelectedStatus', {
          myindex: index,
          mystatus: false,
        });
        this.conselectedShowStatus = _.cloneDeep(this.selectedStatus2);
      } else {
        this.$store.commit('exam/setSelectedStatus', {
          myindex: index,
          mystatus: true,
        });
        this.conselectedShowStatus = _.cloneDeep(this.selectedStatus2);
      }
    },
    sohwDetial_method(index, status) {
      this.$store.commit('exam/setSelectedShowDetial', {
        myindex: index,
        mystatus: status,
      });
      this.conselectedShowDetial = _.cloneDeep(this.selectedShowDetial);
      this.AnalyzeTypeList[index] = 'student';
    },
    ShowCorrectAns(AllAns, SelectedAns) {
      let isCorrect = false;

      const temp = AllAns.indexOf(SelectedAns);

      if (temp !== -1) {
        isCorrect = true;
      } else {
        isCorrect = false;
      }
      return isCorrect;
    },
    errorSubmit(errQu) {

      this.errMsg = '';
      this.ErrorQuestionTemp = {};
      this.ErrorQuestionTemp = errQu;
    },
    modifyQuestions(modifyQu) {
      this.ModifyQuestionTemp = {};
      this.ModifyQuestionTemp = modifyQu;
    },

    selectAns(index, value, index2) {
      if (!this.finish2) {
        if (!this.single) {
          this.qkey = this.AllAns[index - 1].group;
          this.proqkey2 = index;
        } else if (this.totalQuestion === index) {
          this.qkey = this.AllAns[index - 1].group;
          this.proqkey2 = index;
        } else {
          this.qkey = this.AllAns[index - 1].group;
          this.proqkey2 = index;

        }
        if (this.totalQuestion >= index) {
          this.$emit('qkey2', this.qkey);
        }
        this.conselectedAns = {};
        this.conselectedAns = this.selectedAns;


        this.$store.dispatch('exam/writeAns', {
          myindex: index,
          myvalue: value,
          mystatus: true,
        });
        this.$store.commit('exam/setSelectedStatus', {
          myindex: index,
          mystatus: false,
        });
        this.conselectedShowStatus = _.cloneDeep(this.selectedStatus2);

      }
    },
    selectAns2(index, value, index2) {

    },
    showMsgBoxOne() {
      this.$store.dispatch('exam/checkFinish');
      console.log(this.message1)
      this.$bvModal.msgBoxConfirm(this.message1,
        {
          okTitle: '確定',
          cancelTitle: '取消',
          size: 'sm',
          buttonSize: 'md',
          okVariant: 'deepgold',
          cancelVariant: 'light',
          headerClass: 'p-2 border-bottom-0',
          footerClass: 'p-2 border-top-0',
          centered: true
        }).then((value) => {
        if (value) {
          this.$store.dispatch('exam/calculationScore');
          this.$store.commit('exam/setTimes', true);
          this.$store.commit('exam/saveFinish', {
            tf: true,
          });
          this.$store.dispatch('exam/check', false);
          this.reload = false;

          this.$scrollTo('head', 500);
        } else {

          this.$store.commit('exam/setTimes', false);
          this.$store.commit('exam/saveFinish', {
            tf: false,
          });
        }
      });
    },
    tagQuestion(number) {

      if (this.questionTag[number - 1] === true) {
        this.$store.commit('exam/setTag', {
          index: number,
          status: false,
        });
        this.questionTag_clone = _.cloneDeep(this.questionTag);
        this.$emit('emitTag', this.questionTag_clone);
      } else {
        this.$store.commit('exam/setTag', {
          index: number,
          status: true,
        });
        this.questionTag_clone = _.cloneDeep(this.questionTag);
        this.$emit('emitTag', this.questionTag_clone);
      }

    },
  },
  computed: {
    getshowinfoquestion() {
      return (data) => {
        return this.showquestionlist.indexOf(data.id) > -1;
      }
    },
    questionTag: {
      get() {
        return this.$store.state.exam.questionTag;
      },
    },
    toZh: {
      get() {
        return this.$store.state.exam.toZh;
      },
    },
    message1: {
      get() {
        return this.$store.state.exam.message;
      },
    },
    AnalyzeTypeList: {
      get() {
        return this.$store.state.exam.AnalyzeTypeList;
      },
    },
    selectedShowDetial: {
      get() {
        return this.$store.state.exam.selectedShowDetial;
      },
    },
    showDetial: {
      get() {
        return this.$store.state.exam.showDetial;
      },
    },
    msgAnalyze: {
      get() {
        return this.$store.state.exam.msgAnalyze;
      },
    },
    allwaysAns: {
      get() {
        return this.$store.state.exam.allwaysAns;
      },
    },
    userinfo: {
      get() {
        return this.$store.state.indexPage.userinfo;
      },
    },
    qa_method: {
      get() {
        return this.$store.state.exam.questions.method;
      },
    },
    AllAns: {
      get() {
        return this.$store.state.exam.questions.questionAns;
      },
    },
    selectedAns: {
      get() {
        return this.$store.state.exam.selectedAns;
      },
    },
    selectedStatus: {
      get() {
        return this.$store.state.exam.selectedStatus;
      },
    },
    selectedStatus2: {
      get() {
        return this.$store.state.exam.selectedStatus2;
      },
    },
    selectedValue: {
      get() {
        return this.$store.state.exam.selectedValue;
      },
    },
    totalQuestion: {
      get() {
        return this.$store.state.exam.questions.totalQuestion;
      },
    },
    questions: {
      get() {
        return this.$store.state.exam.questions.result;
      },
      set(data) {

      },
    },
    questionsLength() { 
      
    },
    single: {
      get() {
        return this.$store.state.exam.single;
      },
    },
    finish2: {
      get() {
        return this.$store.state.exam.finish;
      },
    },
    ansStatus2: {
      get() {
        return this.$store.state.exam.ansStatus2;
      },
    },
    getfillquestion() {
      return (questionnumber) => {
        // console.log(questionnumber, this.proqkey2, this.proqkey2 == questionnumber);
        return !this.single || this.proqkey2 == questionnumber;
      }
    },
    getactive() {
      return (data, index, item) => {
        if (item.fill || item.read) {
          const a = _.reduce((item.fill || item.read).data, (cur, item, keys) => {
            return cur || this.getfillquestion(item.questionnumber);
          }, false);
          return a
          // if (this.getfillquestion(item)) {
          //   console.log(data, index, item, item.fill.data.length, index + item.fill.data.length);
          //   return true;
          // } else { 
          //   return false
          // }
          // index , item.fill.data.length
          // return data == index;
        } else {
          return data == index;
        }
      };
    }
  },
  watch: {
    allwaysAns() {
      if (this.allwaysAns === false) {
        this.conselectedAns = [];
        this.conselectedShowDetial = [];
        this.questionTag_clone = _.cloneDeep(this.questionTag);
        this.$emit('emitTag', this.questionTag_clone);
      }
    },
    proRe() {
      if (this.proRe) {
        this.conselectedAns = {};
      }
    },
    AnalyzeTypeList() {},
    proOpenAns() {
      this.conselectedShowStatus = _.cloneDeep(this.ansStatus2);
    },
    proqkey() {
      this.qkey = this.proqkey;
    },
    qkeyf2() {
      this.proqkey2 = this.qkeyf2;
    },
  },
  created() {
    this.qkey = this.proqkey;
    this.msgAnalyzeTemp = _.cloneDeep(this.msgAnalyze);
    // this.conselectedShowStatus = _.cloneDeep(this.proStatus);
  },
  mounted() {},
  components: {
    questionItem
  }
};
